import { Box, FormHelperText, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState, useEffect } from 'react';
import OtpInput, { InputProps } from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { getInvestorJointHolderDetails, getInvestorTokenCompany, getRoleBasedPermissions, getUserInfo, newVerifyLoginOtp, showError, verifyLoginEmail } from '../../redux-store/actions/auth';
import { useHistory } from 'react-router';
import { LoginLayout, OtpTimer } from '../commonComponents';
import { getInvestorTokenWithCompany, getOtpForInvestor, getOtpForPaymentFlow, verifyOtpForInvestor, verifyOtpForPayment } from '../../redux-store/actions/onBoarding';
import { Location } from 'history';
import { loginWithOtp } from '../../redux-store/actions/auth';
import {
  GetInvestorJointHolderDetailsResponseBody,
  GetInvestorTokenCompanyResponseBody,
  GetOtpForInvestorResponse,
  GetRoleBasedPermissionsResponseBody,
  LoginWithOtpResponseBody,
  verifyInvestorResponse,
  VerifyLoginEmailResponseBody,
  VerifyLoginOtpResponseBody,
  VerifyPaymentResponse,
} from '../../redux-store/types/api-types';
import { Formik } from '../../lib/formik/Formik';
import { MFSubmitButton } from '../../lib/formik';
import { GET_USER_INFO_SUCCESS, LOGOUT_SUCCESS, VERIFY_LOGIN_OTP, VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { USER_ROLES } from '../../utils/constant';
import { storeApplicationId, storeInterfaceCode, storeInvestorClientId, storeIwappId } from '../../redux-store/actions/id';
import { setInvestorRmId } from '../../redux-store/actions/sessionData';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const intialValues: { OTP: string } = {
  OTP: '',
};

interface RouterState extends LoginWithOtpResponseBody, VerifyLoginEmailResponseBody {
  loginType: string;
  referenceId: string;
  paymentId: string;
}

export default function LoginOtp({ location }: { location: Location<RouterState> }): JSX.Element {
  const {
    phone = "",
    email = "",
    countryCode = "",
    userId = null,
    roles = [],
    isEmailVerificationRequired = false,
    unMaskedPhone = "",
    unMaskedEmail = "",
    userRole = "",
    loginType = "",
    referenceId = "",
    paymentId = ""
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState<string>('');
  const [{ verificationToken }, setVerifyOtpInfo] = useState({ verificationToken: '' });
  const [isLoading, setLoading] = useState<boolean>(false)
  const [isPasswordVisible, setPasswordVisible] = useState<boolean>(false)

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));
  const isXs = useMediaQuery(theme.breakpoints.up('xs'));

  const handleSubmit = async (values: { OTP: string }, { resetForm }: { resetForm: () => void }) => {

    const { OTP } = values;
    try {
      setLoading(true)

      if (!OTP || OTP.length !== 6) {
        setError('Please Enter 6 Digit OTP');
        return;
      }

      if (loginType === 'payment') {
        try {
          const paymentRes = await (dispatch(verifyOtpForPayment(
            referenceId, {
            otp: OTP,
            verificationToken,
            email: unMaskedEmail ?? "",
            userRole: userRole ?? ""
          })) as unknown) as VerifyPaymentResponse;
          if (paymentRes?.token) {
            const payload = {
              clientCode: paymentRes?.clientCode
            }
            const tokenWithCompanyRes = await (dispatch(getInvestorTokenWithCompany(payload)) as unknown) as verifyInvestorResponse
            if (tokenWithCompanyRes?.token) {
              history.push('payment-details', {
                clientCode: paymentRes?.clientCode,
                portfolioId: paymentRes?.portfolioId
              })
            }
          }
        }
        catch (e) {
          console.log(e);
        };
        return;
      }
      if (loginType === 'investor') {
        const res = await dispatch(verifyOtpForInvestor(
          referenceId,
          {
            otp: OTP,
            verificationToken,
            email: unMaskedEmail ?? "",
            userRole: userRole ?? ""
          }) as unknown as Promise<verifyInvestorResponse>);
        if (res?.token) {
          await dispatch(getUserInfo());
          history.push(`application-details`);
        }
        return
      }

      const verifyLoginOtpRes = await (dispatch(newVerifyLoginOtp({
        phone: unMaskedPhone ?? "",
        otp: OTP,
        verificationToken: verificationToken ?? "",
        countryCode: countryCode ?? "",
        userRole: userRole ?? "",
        email: unMaskedEmail ?? ""
      })) as unknown) as VerifyLoginOtpResponseBody

      if (!verifyLoginOtpRes) {
        return
      }

      if (verifyLoginOtpRes?.role === 'investor' && loginType === '') {

        const investorJointHolderRes = await dispatch(getInvestorJointHolderDetails({
          temporaryToken: verifyLoginOtpRes.token,
          body: {
            email: verifyLoginOtpRes?.roles?.[0]?.email ?? ""
          }
        }) as unknown as Promise<GetInvestorJointHolderDetailsResponseBody>)


        if (investorJointHolderRes.isSuccess) {
          if (investorJointHolderRes?.data?.accountList?.length === 1) {
            dispatch(storeInvestorClientId({ investorClientId: investorJointHolderRes?.data?.accountList[0]?.clientCode }));
            dispatch(storeInterfaceCode(investorJointHolderRes?.data?.accountList[0]?.clientInterfaceCode));
            dispatch(storeIwappId({ iwappRmId: investorJointHolderRes?.data?.accountList[0]?.rmId ?? "" }));
            dispatch(setInvestorRmId(investorJointHolderRes?.data?.accountList[0]?.rmId ?? ''))

            const showDiyInvestorOnboarding = investorJointHolderRes?.data?.accountList?.[0]?.status?.toLowerCase() === "draft"
            const showDiyInvOnboardingPrev = !['draft', 'completed'].includes(investorJointHolderRes?.data?.accountList?.[0]?.status?.toLowerCase());

            const tokenWithCompanyRes = await dispatch(getInvestorTokenCompany({
              clientCode: investorJointHolderRes?.data?.accountList?.[0]?.clientCode,
              applicationId: investorJointHolderRes?.data?.accountList?.[0]?.id,
              temporaryToken: verifyLoginOtpRes.token
            }) as unknown as Promise<GetInvestorTokenCompanyResponseBody>)

            if (tokenWithCompanyRes.isSuccess) {
              const permissionResponse = await dispatch(getRoleBasedPermissions({
                temporaryToken: tokenWithCompanyRes?.token ?? ""
              }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>)

              dispatch(storeApplicationId({ applicationId: investorJointHolderRes?.data?.accountList?.[0]?.id }))
              dispatch({
                type: VERIFY_LOGIN_OTP_SUCCESS,
                body: {
                  ...tokenWithCompanyRes,
                  diyInvestorOnboardingEdit: showDiyInvestorOnboarding,
                  diyInvOnboardingPrev: showDiyInvOnboardingPrev,
                  permissions: permissionResponse?.permissions[`${tokenWithCompanyRes?.role ?? ""}`.toLowerCase()] ?? []
                }
              })

              if (showDiyInvestorOnboarding) {
                dispatch(showError("Please complete your onboarding journey"))
                history.replace('/investor-onboarding-application/personal-details', { id: investorJointHolderRes?.data?.accountList?.[0]?.id });
              }
            }

          } else {

            history.push('joint-holder', {
              ...verifyLoginOtpRes,
              jointHolderData: investorJointHolderRes.data.accountList

            })
          }
        }
      } else {
        const permissionsSelectionCriteria = verifyLoginOtpRes?.subRole ? verifyLoginOtpRes?.subRole : verifyLoginOtpRes?.role;

        const permissionResponse = await dispatch(getRoleBasedPermissions({
          temporaryToken: verifyLoginOtpRes?.token ?? ""
        }) as unknown as Promise<GetRoleBasedPermissionsResponseBody>)

        dispatch({
          type: VERIFY_LOGIN_OTP_SUCCESS,
          body: {
            ...verifyLoginOtpRes,
            permissions: permissionResponse?.permissions[`${permissionsSelectionCriteria ?? ""}`.toLowerCase()] ?? []
          }
        });
      }

    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
      resetForm();
    }
  };

  useEffect(() => {
    const { verificationToken } = location.state || {};
    if (!location.state) {
      history.push('/login');
    }
    setVerifyOtpInfo({ verificationToken });
  }, []);

  const onResend = async () => {
    try {
      setLoading(true)
      if (loginType === 'payment') {
        const response = (await dispatch(
          getOtpForPaymentFlow(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      if (loginType === 'investor') {
        const response = (await dispatch(
          getOtpForInvestor(referenceId)
        )) as unknown as GetOtpForInvestorResponse;
        setVerifyOtpInfo({ ...response });
        return;
      }
      if (isEmailVerificationRequired) {
        const res = await dispatch(verifyLoginEmail({
          phone: unMaskedPhone ?? "",
          countryCode: countryCode ?? "",
          email: unMaskedEmail ?? "",
          userId: Number(userId ?? ""),
          userRole: userRole ?? ""
        }) as unknown as Promise<VerifyLoginEmailResponseBody>)

        setVerifyOtpInfo({ ...res });
      } else {
        const res = (await dispatch(
          loginWithOtp({
            phone: unMaskedPhone ?? "",
            countryCode: countryCode ?? ""
          })
        )) as unknown as LoginWithOtpResponseBody;
        setVerifyOtpInfo({ ...res });
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  }

  return (
    <LoginLayout LoginText="Login with OTP">
      <Formik initialValues={intialValues} onSubmit={handleSubmit}>
        {({ values, setValues, handleSubmit }) => (
          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Typography sx={{ color: 'primary.800', textAlign: 'center', mb: 3.5 }}>
              An OTP has been sent to your mobile number
              <Typography component="span">{` ${phone} `}</Typography>
              {email && (
                <Typography component="span">
                  and email Id{' '}
                  <Typography component="span" sx={{ wordBreak: 'break-all' }}>
                    {' '}
                    {email}
                  </Typography>
                </Typography>
              )}
            </Typography>
            <Box
              role="group"
              aria-label="Enter OTP, 6 digit verification code"
              sx={{
                mb: 0,
                '.otp-input': {
                  input: {
                    width: { xs: '37px !important', md: '45px !important' },
                    fontSize: { xs: '20px !important', md: '30px !important' },
                    margin: { xs: '2px !important', md: '4px !important' },
                  },
                },
              }}>
              <OtpInput
                inputType='number'
                renderInput={(inputProps: InputProps) => (
                  <input
                    {...inputProps}
                    type={isPasswordVisible ? 'text' : 'password'}
                    style={{ ...inputProps.style }}
                    disabled={isLoading}
                    aria-invalid={error ? true : undefined}
                    aria-describedby={error ? 'otp-error' : undefined}
                  />
                )}
                value={values.OTP}
                // isDisabled={isLoading}
                onChange={(OTP: string) => setValues({ OTP })}
                numInputs={6}
                // hasErrored={!!error}
                // isInputNum={true}
                // isInputSecure={true}
                shouldAutoFocus={true}
                containerStyle={{
                  display: 'flex',
                  justifyContent: 'center',
                  // flexWrap: 'wrap',
                }}
                inputStyle={{
                  width: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  height: !isSm ? '35px' : !isMd ? '40px' : '45px',
                  // padding: '5px 10px',
                  // // width: '45px',
                  borderRadius: '5px',
                  fontSize: !isSm ? '22px' : '30px',
                  borderColor: error ? `${theme.palette.error[900]}` : `${theme.palette.text.primary}`,
                  color: error ? `${theme.palette.error[900]}` : `${theme.palette.text.primary}`,
                  outline: 'none'
                }}
                renderSeparator={() => (
                  <span style={{ width: '6px' }}></span>
                )}

              // errorStyle={{ border: '2px solid red', color: 'red' }}
              // focusStyle={{ outline: 'none' }}
              // className="otp-input"
              />
              {!!error && (
                <FormHelperText
                  error
                  id="otp-error"
                  role="alert"
                  sx={{ mt: 2, textAlign: 'center', fontSize: '14px', color: `${theme.palette.error[900]}`, fontWeight: 500 }}
                >
                  {error}
                </FormHelperText>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "0.5rem"
              }}
            >
              <IconButton
                sx={{
                  display: "flex",
                  columnGap: "0.5rem",
                  borderRadius: "1rem",
                }}
                onClick={togglePasswordVisibility}
                disabled={isLoading}
              >
                {isPasswordVisible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                <Typography
                  variant='subtitle_600'
                  sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 500
                  }}
                >
                  {isPasswordVisible ? "Hide OTP" : "Show OTP"}
                </Typography>
              </IconButton>
            </Box>
            <Box
              sx={{
                '.MuiTypography-root, .MuiButton-root': {
                  textAlign: 'center',
                },
              }}>
              <OtpTimer onResend={onResend} />
            </Box>
            <Box
              my={1}
              sx={{
                fontSize: 14,
                color: theme.palette.error[500],
                textAlign: 'center',
                // marginBottom: -2,
              }}>
              Note: User Account will be locked after 3 unsuccessful attempts, Resend otp can be
              requested 2 times for every hour
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <MFSubmitButton label="Submit" loadingEnable={isLoading} />
            </Box>
          </Box>
        )}
      </Formik>
    </LoginLayout>
  );
}
